import React, {useCallback, useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from 'react-redux'
import CirclePlus from "../../assets/icons/CirclePlus";
import CrossCircle from "../../assets/icons/CrossCircle";
import GrayQuestionMark from "../../assets/icons/GrayQuestionMark";
import {createTheme, MuiThemeProvider} from "@material-ui/core/styles";
import {tableTheme} from "../../components/customTable/TableTheme";
import ActionsOptions from "../../components/customTable/ActionsOptions";
import ActionsWrapper from "../../components/customTable/ActionsWrapper";
import EditButton from "../../components/customTable/EditButton";
import {languageActions} from "../../store/language/languageSlice";
import DeleteButton from "../../components/customTable/DeleteButton";
import SearchButton from "../../components/customTable/SearchButton";
import FilterButton from "../../components/customTable/FilterButton";
import {StaticTableOptions} from "../../components/customTable/StaticTableOptions";
import AddButton from "../../components/customTable/AddButton";
import {addLanguageData, deleteLanguageData, fetchLanguageData, updateLanguageData} from "../../store/language/languageActions";
import MUIDataTable from "mui-datatables";
import DeleteDialog from "../../components/dialogs/DeleteDialog";
import AddDialog from "../../components/dialogs/AddDialog";
import DialogHeader from "../../components/dialogs/DialogHeader";
import TextInput from "../../components/textInput/TextInput";

function Languages({ getMuiTheme = () => createTheme(tableTheme) }) {

    const dispatch = useDispatch()
    const language = useSelector(state => state.userInfos.language)
    const languages = useSelector(state => state.bookLanguages.languages)
    const isLanguage = useSelector(state=>state.bookLanguages.language)
    const TableOptions = useSelector(state => state.tableOptions.options)
    const [openAdd, setOpenAdd] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [languageId, setLanguageId] = useState(false)

    const cancelAddRef = useRef(null)
    const cancelDeleteRef = useRef(null)

    const [sendLanguage, setSendLanguage] = useState({})

    const cols = [
        {
            name: "name",
            label: language.language_name,
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta) => {
                    return (
                        <div>{value}</div>
                    );
                }
            }
        },
        {
            name: "code",
            label: language.language_code,
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta) => {
                    return (
                        <div>{value}</div>
                    );
                }
            }
        },
        {
            name: "",
            options: {
                ...ActionsOptions,
                customBodyRender: (value, tableMeta, rowIndex) => {
                    return (
                        <ActionsWrapper>
                            <EditButton
                                onClick={() => {
                                    setOpenEdit(true)
                                    setOpenAdd(true)
                                    setSendLanguage(languages[tableMeta.rowIndex])
                                    dispatch(languageActions.getLanguage(languages[tableMeta.rowIndex]))
                                }}
                            />
                            <DeleteButton
                                onClick={() => {
                                    setLanguageId(languages[tableMeta.rowIndex].code)
                                    dispatch(languageActions.getLanguage(languages[tableMeta.rowIndex]))
                                    setOpenDelete(true)
                                }
                                }
                            />
                        </ActionsWrapper>
                    );
                }
            }
        }];

    const components = {
        icons: {
            SearchIcon: SearchButton,
            ViewColumnIcon: FilterButton,
        }
    }

    const options = {
        ...TableOptions, ...StaticTableOptions,
        selectableRows: "multiple",
        customToolbar: () => {
            return (
                <AddButton onClick={() => {
                    setOpenAdd(true)
                    setOpenEdit(false)
                }} />
            )
        }
    }

    const saveLanguage = () => {
        dispatch(addLanguageData(sendLanguage))
        setOpenAdd(false)
    }

    const deleteLanguage = () => {
        dispatch(deleteLanguageData(languageId))
        setOpenDelete(false)
    }

    const editLanguage = () => {
        dispatch(updateLanguageData(sendLanguage))
        setOpenEdit(false)
        setOpenAdd(false)
    }

    useEffect(() => {
        dispatch(fetchLanguageData())
    }, [dispatch,isLanguage])

    return (
        <div>
            <div className="container mt-3 px-3 mx-auto max-w-screen-lg data-table">
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        className="w-full z-0"
                        title={language.languages}
                        data={languages}
                        columns={cols}
                        options={options}
                        components={components}
                    />
                </MuiThemeProvider>
            </div>
            <DeleteDialog
                openDelete={openDelete}
                cancelDeleteRef={cancelDeleteRef}
                setOpenDelete={setOpenDelete}
                deleteItem={deleteLanguage}
                title={language.delete_region}
            />
            <AddDialog
                isEdit={openEdit}
                openAdd={openAdd}
                setOpenEdit={setOpenEdit}
                setOpenAdd={setOpenAdd}
                cancelAddRef={cancelAddRef}
                saveItem={saveLanguage}
                editItem={editLanguage}
            >
                <DialogHeader
                    closeModal={() => {setOpenAdd(false)}}
                    title={openEdit ? language.edit_language : language.add_language}
                />
                <TextInput
                    value={openEdit ? sendLanguage.name : null}
                    onChange={(e) => setSendLanguage({ ...sendLanguage, name: e.target.value })}
                    placeholder={language.language_name}
                    label={language.language_name}
                />
                <TextInput
                    value={openEdit ? sendLanguage.code : null}
                    onChange={(e) => setSendLanguage({ ...sendLanguage, code: e.target.value })}
                    placeholder={language.language_code}
                    label={language.language_code}
                />
            </AddDialog>
        </div>
    );
}

export default Languages;